export default __webpack_public_path__ + "static/media/Treasure.cf825e34.png";